// src/utils/remoteConfigUtils.js

import { getConfigValue } from "./remoteConfigService";

/**
 * @returns {string} The wedding date from Remote Config.
 */
export const getWeddingDate = () => {
  return getConfigValue("wedding_ceremony_date").asString();
};

/**
 * @returns {string} The rsvp expiry date from Remote Config.
 */
export const getRsvpExpiredDate = () => {
  return getConfigValue("rsvp_expired_date").asString();
};
